import React, {
  FC,
  Fragment,
  PropsWithChildren,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import styled from "styled-components";
import { getDistance } from "../functions/getDistance";
import { ScrollBarConfig } from "../functions/ScrollBarConfig";
import { Store } from "../interfaces/IStore";
import { AppContext } from "./AppContext";
import AirbnbResults from "./Icons/AirbnbResults";
import HotelResults from "./Icons/HotelResults";
import StoreResults from "./Icons/StoreResults";
import { MapContext } from "./MapContext";

interface IStoreList {
  label?: string;
  isMobile?: boolean | undefined;
  onClick: (store: Store) => void;
}

const ResultsContainer = styled.div`
  display: flex;
  flex-flow: column;
  overflow-y: hidden;
  min-height: 36.375px;
  margin: 0;
  border-top: 0.2rem solid white;
  height: auto;
  padding-top: 0.4rem;
  height: 16.5rem !important;
  max-height: 16.5rem;
  border-bottom: 1px solid #c0bebe;
  border: solid red;
`;

const ResultsHeader = styled.div`
  height: 30px;
  color: black;
  min-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 1rem;
`;

const StoreTitle = styled.div`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.5px;
  font-weight: 700;
  padding: 0.5rem;
  padding-top: 10px;
`;

const ArrowIcon = styled.img`
  width: 20px;
  height: 20px;
  top: 4px;
  right: 10px;
  transition: 0.3s ease-in-out;
`;

const Filters = styled.div`
  overflow-y: scroll;
  flex-shrink: 1;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  margin: 0.2rem 0 0 0.4rem;
  margin-left: 0.9rem;
  margin-right: 0.9rem;
  // ::-webkit-scrollbar {
  //   display: none;
  // }

  ${ScrollBarConfig}
`;

const StoreCardMainContainer = styled.div`
  margin: 0.8rem 0.6rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StoreCardHeader = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 1;
`;

const ResultCardStoreTitle = styled.p`
  font-size: 18px;
  line-height: 1.3;
  letter-spacing: 0.5px;
  margin: 0px 0;
  cursor: pointer;
  padding-left: 10px;
`;

const StoreIconElement = styled.img`
  width: 1.2rem;
  height: 1.2rem;
`;

export const ResultsList: FC<PropsWithChildren<IStoreList>> = ({
  label,
  onClick,
  isMobile,
}) => {
  const { stores } = useContext(AppContext);
  const { sortCoords } = useContext(MapContext);
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const containerRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    isMobile
      ? (containerRef.current.style.height = "11rem")
      : (containerRef.current.style.height = "auto");
  }, []);

  let ResultsContainer;

  isMobile
    ? (ResultsContainer = styled.div`
        display: flex;
        flex-flow: column;
        overflow-y: hidden;
        min-height: 36.375px;
        margin: 0;
        border-top: 0.2rem solid white;
        height: auto;
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
        height: 16.5rem !important;
        max-height: 16.5rem;
        border-bottom: 1px solid #c0bebe;
      `)
    : (ResultsContainer = styled.div`
        display: flex;
        flex-flow: column;
        overflow-y: hidden;
        min-height: 36.375px;
        margin: 0;
        border-top: 0.2rem solid white;
        height: auto;
        padding-top: 0.4rem;
        height: calc(100vh - 51px - 0.6rem - 135px - 14rem);
      `);

  return (
    <Fragment>
      <ResultsContainer ref={containerRef}>
        {isMobile ? null : label ? (
          <ResultsHeader>
            <StoreTitle> {label} </StoreTitle>
          </ResultsHeader>
        ) : null}

        {isOpen ? (
          <Filters>
            {stores
              .filter((store) => store.business_type !== "competitor")
              .map((store, index) => {
                const distance = (
                  getDistance(
                    [sortCoords.lat, sortCoords.lng],
                    [store.latitude, store.longitude]
                  ) / 1000
                ).toFixed(0);

                return (
                  <StoreCardMainContainer key={index}>
                    <StoreCardHeader onClick={() => onClick(store)}>
                      <div>
                        {store.business_type === "airbnb" ? (
                          <AirbnbResults />
                        ) : store.business_type === "hotel" ? (
                          <HotelResults />
                        ) : (
                          <StoreResults />
                        )}
                      </div>
                      <ResultCardStoreTitle>
                        {store.name_en}
                      </ResultCardStoreTitle>
                    </StoreCardHeader>
                    <DistanceContainer>{distance}km</DistanceContainer>
                  </StoreCardMainContainer>
                );
              })}
          </Filters>
        ) : null}
      </ResultsContainer>
    </Fragment>
  );
};

const DistanceContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
`;
